import { Checkbox, Theme, useStyles } from 'bold-ui'
import { DateTime } from 'components/date'
import React, { CSSProperties } from 'react'

import { AgendamentoDia } from '../types/AgendamentoDia'

export interface AgendamentosDiaCheckFieldProps {
  agendamento: AgendamentoDia
  checked: boolean
  onChange(value: string): void
}

export function AgendamentosDiaCheckField(props: AgendamentosDiaCheckFieldProps) {
  const { classes } = useStyles(createStyles)
  const { agendamento, checked, onChange } = props

  const agendamentosDiaLabelRender = (name: string, time: string) => {
    return (
      <div
        style={{
          fontWeight: 'bold',
          marginLeft: '0.5rem',
        }}
      >
        <DateTime value={time} format='HH:mm' />
        {' - ' + name}
      </div>
    )
  }

  return (
    <Checkbox
      style={classes.AgendamentosDiaCheck}
      label={agendamentosDiaLabelRender(agendamento.lotacaoAgendada.profissional.nome, agendamento.horarioInicial)}
      value={agendamento.id}
      onChange={(e) => {
        onChange(e.target.value)
      }}
      checked={checked}
    />
  )
}

const createStyles = (theme: Theme) => ({
  AgendamentosDiaCheck: {
    width: '100%',
    background: theme.pallete.surface.main,
    padding: '1.25rem 1rem 1.25rem 0.75rem',
    borderRadius: '2px',
    border: `1px solid ${theme.pallete.gray.c60}`,
  } as CSSProperties,
})
